export default "/icons/sass_icon.svg";